/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Status_Pending_HintInputs */

const en_us2_body_assessment_status_pending_hint = /** @type {(inputs: Body_Assessment_Status_Pending_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It takes a few seconds. You can leave this screen.`)
};

const pt_br2_body_assessment_status_pending_hint = /** @type {(inputs: Body_Assessment_Status_Pending_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leva alguns segundos. Você pode sair desta tela.`)
};

const es_419_body_assessment_status_pending_hint = /** @type {(inputs: Body_Assessment_Status_Pending_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarda unos segundos. Puedes salir de esta pantalla.`)
};

const pt_pt2_body_assessment_status_pending_hint = /** @type {(inputs: Body_Assessment_Status_Pending_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Demora alguns segundos. Podes sair deste ecrã.`)
};

const fr_fr2_body_assessment_status_pending_hint = /** @type {(inputs: Body_Assessment_Status_Pending_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ça prend quelques secondes. Tu peux quitter cet écran.`)
};

const de_de2_body_assessment_status_pending_hint = /** @type {(inputs: Body_Assessment_Status_Pending_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das dauert ein paar Sekunden. Du kannst diesen Bildschirm verlassen.`)
};

const it_it2_body_assessment_status_pending_hint = /** @type {(inputs: Body_Assessment_Status_Pending_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ci vuole qualche secondo. Puoi lasciare questa schermata.`)
};

/**
* | output |
* | --- |
* | "It takes a few seconds. You can leave this screen." |
*
* @param {Body_Assessment_Status_Pending_HintInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_status_pending_hint = /** @type {((inputs?: Body_Assessment_Status_Pending_HintInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Status_Pending_HintInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_status_pending_hint(inputs)
	if (locale === "es-419") return es_419_body_assessment_status_pending_hint(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_status_pending_hint(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_status_pending_hint(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_status_pending_hint(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_status_pending_hint(inputs)
	return en_us2_body_assessment_status_pending_hint(inputs)
});
export { body_assessment_status_pending_hint as "body-assessment.status_pending_hint" }